import {Axios} from "../../../axiosHelper";
import {AxiosError, AxiosResponse} from "axios";
import {AddRegisterRequest, EditRegisterRequest, RegisterListResponse, TemplateListResponse} from "../../data/register";
import {registerActions} from "../../slice/efe/registerSlice";
import {ResponseBase} from "../../data";
import {userActions} from "../../slice/atr/userSlice";

export const getTemplatesList = (): any => {
    return async (dispatch: any) => {
        dispatch(registerActions.setLoading(true));

        Axios.get(`/efe/register/template/list`)
            .then((res: AxiosResponse<TemplateListResponse>) => {
                dispatch(registerActions.setTemplatesList(res.data.templateList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(registerActions.setError(resp));
                    }
                }
            });
    };
};

export const getRegisterList = (podTag: string): any => {
    return async (dispatch: any) => {
        dispatch(registerActions.setLoading(true));

        Axios.get(`/efe/register/list/${podTag}`)
            .then((res: AxiosResponse<RegisterListResponse>) => {
                dispatch(registerActions.setRegisterList(res.data.registerList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(registerActions.setError(resp));
                    }
                }
            });
    };
};

export const newRegister = (podTag: string, request: AddRegisterRequest): any => {
    return async (dispatch: any) => {
        dispatch(registerActions.setLoading(true));

        Axios.post(`/efe/register/new/${podTag}`, request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(registerActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(registerActions.setResponse(resp));
                        dispatch(registerActions.setError(resp));
                    }
                }
            });
    };
};

export const editRegister = (request: EditRegisterRequest): any => {
    return async (dispatch: any) => {
        dispatch(registerActions.setLoading(true));

        Axios.put(`/efe/register/edit`, request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(registerActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(registerActions.setResponse(resp));
                        dispatch(registerActions.setError(resp));
                    }
                }
            });
    };
};

export const deleteRegister = (regId: number): any => {
    return async (dispatch: any) => {
        dispatch(registerActions.setLoading(true));

        Axios.delete(`/efe/register/delete/${regId}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(registerActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(registerActions.setResponse(resp));
                        dispatch(registerActions.setError(resp));
                    }
                }
            });
    };
};

export const clearRegisterResponse = (): any => {
    return async (dispatch: any) => {
        dispatch(registerActions.setResponse(null));
    };
};